import useLenis from "@/hooks/useLenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Spotlight } from "@/components/site/Spotlight";
import { Pillars } from "@/components/site/Pillars";
import { Manifesto } from "@/components/site/Manifesto";
import { About } from "@/components/site/About";
import { JournalStrip } from "@/components/site/JournalStrip";
import { Ebooks } from "@/components/site/Ebooks";
import { Booking } from "@/components/site/Booking";
import { Journal } from "@/components/site/Journal";
import { Testimonials } from "@/components/site/Testimonials";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  return (
    <main className="bg-brand-bg min-h-screen" data-testid="landing-page">
      <Nav />
      <Hero />
      <Marquee />
      <Spotlight />
      <Pillars />
      <Manifesto />
      <About />
      <JournalStrip />
      <Ebooks />
      <Booking />
      <Journal />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}
